/**
 * Wishlist - Shared logic for add/remove, localStorage, events
 * Uses localStorage key intus_wishlist
 */

const WISHLIST_KEY = 'intus_wishlist';
const WISHLIST_UPDATED = 'wishlist:updated';

function getWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function setWishlist(items, options = {}) {
  const { silent = false } = options;
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    if (!silent) {
      document.dispatchEvent(new CustomEvent(WISHLIST_UPDATED, { detail: { items } }));
    }
  } catch (e) {
    console.warn('Wishlist: failed to save', e);
  }
}

function isInWishlist(productId) {
  const items = getWishlist();
  return items.some((item) => String(item.product_id) === String(productId));
}

function addToWishlist(item) {
  const items = getWishlist();
  if (items.some((i) => String(i.product_id) === String(item.product_id))) {
    return false;
  }
  items.push(item);
  setWishlist(items);
  return true;
}

function removeFromWishlist(productId, options = {}) {
  const { silent = false } = options;
  const items = getWishlist().filter((i) => String(i.product_id) !== String(productId));
  setWishlist(items, { silent });
}

function syncAvailability(updates) {
  if (!updates || updates.length === 0) return;
  const items = getWishlist();
  let changed = false;
  const updatedItems = items.map((item) => {
    const update = updates.find((u) => String(u.product_id) === String(item.product_id));
    if (!update) return item;
    changed = true;
    return {
      ...item,
      available: update.available,
      ...(update.price != null ? { price: update.price } : {})
    };
  });
  if (changed) {
    setWishlist(updatedItems, { silent: true });
  }
}

function getWishlistCount() {
  return getWishlist().length;
}

function trackKlaviyoAddedToWishlist(product) {
  const variant = product.variant || product.selected_or_first_available_variant;
  const payload = {
    'Product Name': product.title,
    'Product ID': product.id,
    'Product URL': product.url ? (product.url.startsWith('/') ? (window.shopUrl || '') + product.url : product.url) : null,
    'Product Image': product.image || (product.featured_image ? product.featured_image.src : null),
    'Variant ID': variant?.id ?? null,
    'Value': variant?.price ? variant.price / 100 : null
  };
  if (typeof _learnq !== 'undefined') {
    _learnq.push(['track', 'Added to Wishlist', payload]);
  } else {
    (window._learnq = window._learnq || []).push(['track', 'Added to Wishlist', payload]);
  }
}

function trackKlaviyoRemovedFromWishlist(product) {
  const payload = { 'Product Name': product?.title || product?.name };
  if (typeof _learnq !== 'undefined') {
    _learnq.push(['track', 'Removed from Wishlist', payload]);
  } else {
    (window._learnq = window._learnq || []).push(['track', 'Removed from Wishlist', payload]);
  }
}

window.WishlistService = {
  get: getWishlist,
  set: setWishlist,
  add: addToWishlist,
  remove: removeFromWishlist,
  syncAvailability,
  has: isInWishlist,
  count: getWishlistCount,
  trackAdded: trackKlaviyoAddedToWishlist,
  trackRemoved: trackKlaviyoRemovedFromWishlist,
  WISHLIST_UPDATED
};
